// removed by extract-text-webpack-plugin
module.exports = {"ScrollDiv":"SideScroll__ScrollDiv__1Y3Jl","TextDiv":"SideScroll__TextDiv__jS5IA","Arrow":"SideScroll__Arrow__24BeS","Text":"SideScroll__Text__2oeDv"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Navigation/SideScroll/SideScroll.css
// module id = 391
// module chunks = 0